<script lang="ts">
    import { untrack } from 'svelte';
    import type { Snippet } from 'svelte';
    import { setComparisonContext } from '@shared/providers/comparison-context/ComparisonContext.browser.ts';
    import type { ComparisonContext } from '@shared/providers/comparison-context/ComparisonContext.browser.ts';
    import type { Variation } from '@shared/types/types.ts';
    import { injectWiring } from '@tilelist/application/wiring/TileListWiringContext.svelte.ts';
    import { PandaComparison } from '@tilelist/components/product-comparison/PandaComparison.ts';

    interface Props {
        comparisonId?: string;
        showComparisonOverride?: boolean;
        children: Snippet;
    }

    const { comparisonId, showComparisonOverride, children }: Props = $props();

    const wiring = injectWiring();
    let showComparison = $state(false);
    const comparisonEnabled = $derived(!wiring.onex.isToggleActive('EMERGENCY_DISABLE_PRODUCT_COMPARISON'));

    const comparisonState = $state<ComparisonContext>({
        get comparisonId() {
            return comparisonId || null;
        },
        initialized: false,
        get showComparison() {
            return showComparisonOverride ?? showComparison;
        },
        set showComparison(value: boolean) {
            showComparison = value;
        },
        selectedVariations: [],
        compareLink: null,
        async selectVariation(variation: Variation) {
            await pandaComparison.selectVariation(comparisonState, variation);
        },
        async deselectVariation(id: string) {
            await pandaComparison.deselectVariation(comparisonState, id);
        },
        async clearSelectedVariations() {
            await pandaComparison.clearSelectedVariations(comparisonState);
        },
    });
    setComparisonContext(comparisonState);

    /*               */
    let pandaComparison: PandaComparison;

    /**
 *
 *
 */
    let lastComparisonId = $state(untrack(() => comparisonId));
    $effect(() => {
        if (!comparisonId || !comparisonEnabled) return;

        if (!pandaComparison && wiring.variationLoadingService && wiring.trackingService && wiring.eventsIncoming) {
            pandaComparison = new PandaComparison(
                wiring.variationLoadingService,
                wiring.trackingService,
                wiring.eventsIncoming,
            );
            pandaComparison.initialize(comparisonState);
        }
        if (comparisonId !== lastComparisonId) {
            pandaComparison.updateContext(comparisonState);
            lastComparisonId = comparisonId;
        }
    });
</script>

{@render children()}
